import { george, observer, pr, ui } from "aaa";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { safeWindowOpen } from "util/helpers";
import { AppBusinessStoreRedirectStore } from "./AppBusinessStoreRedirectStore";

const FOOTER_HEIGHT = 64;

const LandingPageHeader = () => (
    <pr.HeaderBackground
        style={{
            alignItems: "center",
            backgroundColor: "#2870ED",
            display: "flex",
            justifyContent: "center",
            height: 235,
            overflow: "hidden",
            position: "relative",
        }}
    >
        <img
            alt="george business app illustration"
            src={require("../../assets/illustration_george_business_app.png")}
            style={{
                height: "auto",
                maxWidth: 220,
                position: "absolute",
                top: 20,
                width: "100%",
            }}
        />
    </pr.HeaderBackground>
);

const LandingPageFooter = () => (
    <div
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            bottom: 0,
            width: "100%",
            height: FOOTER_HEIGHT,
            backgroundColor: "#2870ED",
        }}
    >
        <img
            src={require("../../assets/george_app_footer_logo.svg")}
            alt=""
        />
    </div>
);

export const AppBusinessStoreRedirectSite = observer(({ store }: { store: AppBusinessStoreRedirectStore }) => {
    let redirectUrl: string | undefined;

    if (externalInterfaceStore.isIos) {
        redirectUrl = store.iosStoreUrl;
    } else if (externalInterfaceStore.isAndroid) {
        redirectUrl = store.androidStoreUrl;
    } else if (externalInterfaceStore.isHuawei) {
        redirectUrl = store.appGalleryStoreUrl;
    }

    React.useEffect(() => {
        if (redirectUrl) {
            safeWindowOpen(redirectUrl);
        }
    }, [redirectUrl]);

    if (redirectUrl) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.LandingBackground useWebVersion style={{ boxSizing: "border-box", paddingBottom: FOOTER_HEIGHT, position: "relative" }}>
            <LandingPageHeader />
            <div style={{ padding: 24 }}>
                <pr.P_24_TITLE style={{ textAlign: "center", fontWeight: 600 }}>{ui.__("appBusinessStoreRedirect.landingPage.title")}</pr.P_24_TITLE>
                <pr.P_16_TITLE style={{ textAlign: "center" }}>{ui.__("appBusinessStoreRedirect.landingPage.subTitle")}</pr.P_16_TITLE>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexWrap: "wrap",
                        marginTop: 40,
                        gap: 15
                    }}
                >
                    <a
                        target="_blank"
                        href={store.androidStoreUrl}
                        role="button"
                        title={ui.__("common.download.playStore")}
                    >
                        <img alt="google play store" style={{ height: 50 }} src={externalInterfaceStore.androidStoreIconUrl} />
                    </a>
                    <a
                        target="_blank"
                        href={store.iosStoreUrl}
                        role="button"
                        title={ui.__("common.download.appStore")}
                    >
                        <img alt="ios app store" style={{ height: 50 }} src={externalInterfaceStore.iosStoreIconUrl} />
                    </a>
                    <a
                        target="_blank"
                        href={store.appGalleryStoreUrl}
                        role="button"
                        title={ui.__("common.download.appGallery")}
                    >
                        <img alt="huawei app gallery" style={{ height: 50 }} src={externalInterfaceStore.appGalleryIconUrl} />
                    </a>
                </div>
                <pr.P_16_CONTENT style={{ textAlign: "center", marginTop: 40 }}>
                    {ui.__("appBusinessStoreRedirect.landingPage.description")}
                </pr.P_16_CONTENT>
            </div>
            <LandingPageFooter />
        </george.LandingBackground>
    );
});


// WEBPACK FOOTER //
// ./src/components/appBusinessStoreRedirect/AppBusinessStoreRedirectSite.tsx